import React, { useState, useEffect } from 'react';
import { Table, Button, message, Space, Tag } from 'antd';
import { fetchPorts, deletePort } from '../../services/portService';

const PortManagement = () => {
  const [ports, setPorts] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadPorts = async () => {
    setLoading(true);
    try {
      const data = await fetchPorts();
      setPorts(data);
    } catch (error) {
      message.error('获取关口数据失败');
    }
    setLoading(false);
  };

  useEffect(() => {
    loadPorts();
  }, []);

  const handleBillVerification = async (id) => {
    try {
      // Navigate to bill verification page or open modal
      message.info('账单核对功能开发中');
    } catch (error) {
      message.error('操作失败');
    }
  };

  const handleDelete = async (id) => {
    try {
      await deletePort(id);
      message.success('删除成功');
      loadPorts();
    } catch (error) {
      message.error('删除失败');
    }
  };

  const columns = [
    {
      title: '关口名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '关口ID',
      dataIndex: 'port_id',
      key: 'port_id',
    },
    {
      title: '快递公司',
      dataIndex: 'couriers',
      key: 'couriers',
      render: (couriers) => (
        <Space size={[0, 8]} wrap>
          {couriers.map((courier) => (
            <Tag key={courier.id} color="blue">
              {courier.name}
            </Tag>
          ))}
        </Space>
      ),
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => handleBillVerification(record.id)}>
            账单核对
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={ports}
        rowKey="id"
        loading={loading}
      />
    </div>
  );
};

export default PortManagement;
